/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Lockr from 'lockr';
import { callNativeFunction, nativeFunction, getIdentity } from '@/utils/detectDevice';
// import Lodash from 'lodash';
import {
  DEVICE,
  LIBRARY_ASSETS_ORIGIN_URL,
  STORAGE_KEY,
  IDENTITY_KEY_NAME,
} from '@/constants';
import DeviceContext from '../device-context';
import './style';


class Dot extends Component {
  static propTypes = {
    stage: PropTypes.object,
    percent: PropTypes.number,
    downloaded: PropTypes.bool,
    theme: PropTypes.string,
    stageId: PropTypes.string,
    setDownloadingStatus: PropTypes.func,
    hasDownloadingDot: PropTypes.bool,
  };

  constructor() {
    super();
    this.dotRef = React.createRef();
  }

  state = {
    uid: -1,
    showDownload: true,
    downloading: false,
    showDetail: false,
    detailPosition: '',
    detailLeft: 0,
    detailTop: 0,
    detailOpacity: 0,
    redirect: false,
    imgError: false,
  }

  componentDidMount() {
    window.onfire.on(`entrance-${this.props.stage.shortname}`, (pages) => {
      console.log(pages);
      this.setPageXml({});
      this.setPageXml(pages);
    });
  }

  componentWillReceiveProps(nextProps) {
    const { percent } = nextProps;
    const { downloading } = this.state;
    if (!downloading && percent > 0 && percent < 100) {
      this.setDownloadingFlag({ flag: true });
    } else if (downloading && percent === 0) {
      // console.log('downloading: ', downloading, 'percent: ', percent);
      this.setDownloadingFlag({ flag: false });
    }
  }

  componentDidUpdate() {
    if (Math.min(this.props.percent, 100) === 100 && this.state.downloading) {
      this.downLoadCompleted();
    }
  }

  componentWillUnmount() {
    window.onfire.off(`entrance-${this.props.stage.shortname}`);
  }

  setDownloadingFlag = ({ flag }) => {
    this.setState({ showDownload: !flag, downloading: flag }, () => {
      this.props.setDownloadingStatus(flag);
    });
  };

  startDownload = () => {
    if (!this.props.stage.canEnter) return;
    if (this.props.hasDownloadingDot) {
      callNativeFunction(nativeFunction.TOAST)({
        content: '有一本书正在下载中，请等待……',
      });
      return;
    }
    this.setState({ showDownload: false, downloading: true }, () => {
      const {
        scormPage, cover,
        shortname, size,
      } = this.props.stage;
      const pages = Array.from(
        new Set([
          ...scormPage
            .map(item => item.title)
            .filter(item => item),
          cover,
        ]),
      );
      callNativeFunction(nativeFunction.DOWNLOAD_BOOK)({
        book: shortname,
        pages: pages.join(','),
        size,
      });
      this.props.setDownloadingStatus(true);
    });
  }

  downLoadCompleted = () => {
    setTimeout(() => {
      this.setState(
        { downloading: false },
        () => this.props.setDownloadingStatus(false),
      );
    }, 1000);
  }

  showDetail = () => {
    const wCx = document.documentElement.clientWidth / 2;
    const dotCy = this.dotRef.current.getBoundingClientRect().top + 52 / 2;
    const dotCx = this.dotRef.current.getBoundingClientRect().left + 52 / 2;
    let detailPosition = 'left';
    if (wCx > dotCx) {
      detailPosition = 'right';
    }
    if (dotCy < (215 / 2)) {
      detailPosition = 'bottom';
    }
    if (document.documentElement.clientHeight - dotCy < 215 / 2) {
      detailPosition = 'top';
    }
    this.setState({
      showDetail: true,
      detailPosition,
      detailTop: this.dotRef.current.getBoundingClientRect().top - document.querySelector('.path').getBoundingClientRect().top,
      detailLeft: this.dotRef.current.getBoundingClientRect().left - document.querySelector('.path').getBoundingClientRect().left,
    });
    setTimeout(() => {
      this.setState({ detailOpacity: 1 });
    }, 100);
  }

  hideDetail = () => {
    this.setState({ detailOpacity: 0 });
    setTimeout(() => {
      this.setState({ showDetail: false });
    }, 100);
  }

  goNext = () => {
    if (!this.props.stage.canEnter) return;
    this.context === DEVICE.PC
      ? this.doRoute()
      : this.callNative();
  }

  doRoute = () => {
    this.setState({ redirect: true });
  };

  callNative = () => {
    callNativeFunction(nativeFunction.ENTRANCE_BOOK)({
      name: this.props.stage.shortname,
    });
  };

  setPageXml = async (json) => {
    const uid = await getIdentity(IDENTITY_KEY_NAME.UID);
    this.setState({ uid });
    Lockr.set(STORAGE_KEY.PAGES, json);
    this.doRoute();
  };

  imageOnError = (e) => {
    e.stopPropagation();
    this.setState({ imgError: true });
  }

  render = () => {
    const {
      stage,
      theme,
      percent,
      downloaded,
    } = this.props;
    // console.log('render percent', percent);
    const {
      showDownload,
      downloading,
      showDetail,
      detailPosition,
      detailOpacity,
      detailLeft,
      detailTop,
      redirect,
      imgError,
      uid,
    } = this.state;
    const isPC = this.context === DEVICE.PC;
    const cover = `${LIBRARY_ASSETS_ORIGIN_URL}Library/${stage.cover}/${stage.cover}_Image.png`;
    const downloadClassName = `download${stage.canEnter ? '' : ' disable'}`;
    if (redirect) {
      const { scorm_id: id, attempt } = this.props.stage;
      const { val, type } = Lockr.get(`${uid}${id}`, {});
      const url = val !== 'undefined' && type
        ? `/${type}/${id}/${attempt}/${theme}/${this.props.stageId}`
        : `/cover/${id}/${attempt}/${theme}/${this.props.stageId}`;
      return <Redirect push to={url} />;
    }
    return (
      <React.Fragment>
        <div
          className="dot-item"
          ref={this.dotRef}
          onMouseOver={isPC ? this.showDetail : null}
          onMouseLeave={isPC ? this.hideDetail : null}
          onFocus={() => 0}
        >
          {!isPC && <p className="text">{stage.fullname}</p>}
          <div
            className="dot"
            style={{ backgroundImage: `url(${cover})` }}
            onClick={!isPC && (downloading || showDownload) && !downloaded ? null : this.goNext}
          >
            {isPC && !stage.canEnter && <div className="pcCantDownload" />}
            {/* 完成 */}
            {stage.alreadyRead && <span className="completed" />}
            {/* 下载 */}
            {showDownload && !downloaded && !isPC
              && <div className={downloadClassName} onClick={this.startDownload} />
            }
            {downloading && !downloaded
              ? (
                <div className="downloading">
                  <svg viewBox="0 0 64 64">
                    <circle
                      className="svg-outer-circle"
                      r="25%"
                      cx="50%"
                      cy="50%"
                      strokeDasharray={`${100 - percent} 100`}
                    />
                  </svg>
                </div>
              )
              : ''
            }
          </div>
        </div>
        {showDetail && detailPosition && (
          <div
            className={`stage-detail ${detailPosition}`}
            style={{ transform: `translate(${detailLeft}px,${detailTop}px)`, opacity: detailOpacity }}
          >
            <span />
            <div className={`img-container${imgError ? ' error' : ''}`}>
              {!imgError && <img src={cover} alt=" " onError={e => this.imageOnError(e)} />}
            </div>
            <p><span style={{ WebkitBoxOrient: 'vertical' }}>{stage.fullname}</span></p>
          </div>
        )}
      </React.Fragment>
    );
  }
}

Dot.defaultProps = {
  percent: 0,
};
const DotWithMemo = React.memo(Dot);
Dot.contextType = DeviceContext;

export default DotWithMemo;
